
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'BotoesEdicao',
    props: {
        ehPrimeiro: {
            type: Boolean,
            required: true,
        },
        ehUltimo: {
            type: Boolean,
            required: true,
        },
    },
    computed: {
        classesSubir() {
            return {
                botao: true,
                habilitado: !this.ehUltimo,
                desabilitado: this.ehUltimo,
            };
        },
        classesDescer() {
            return {
                botao: true,
                habilitado: !this.ehPrimeiro,
                desabilitado: this.ehPrimeiro,
            };
        },
    },
    methods: {
        editar() {
            this.$emit('editar');
        },
        excluir() {
            this.$emit('excluir');
        },
        descer() {
            if (!this.ehPrimeiro) {
                this.$emit('descer');
            }
        },
        subir() {
            if (!this.ehUltimo) {
                this.$emit('subir');
            }
        },
    },
    emits: ['excluir', 'descer', 'subir', 'editar'],
});
